<script>
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";

export default {
    name: "CompanyServicesItem",
    components: {TextAccordion, CallbackButton},
    props: {
        rtl: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
        },
        img: {
            type: String,
            required: true,
        },
        is_accordion_on: {
            type: Boolean,
            default: true,
        },
        btnText: {
            type: String,
            default: 'Заказать звонок'
        },
    }
}
</script>

<template>
    <div class="container">
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-5">
            <div class="flex md:justify-center mb-5 md:mb-0 "
                 :class="[
                 rtl ? 'bg-rtl' : 'bg-ltl',
                 rtl ? 'order-1 md:order-2 justify-start' : 'justify-end',
                 ]">
                <img :src="img" :alt="title" :title="title"
                     class="w-full rounded-2xl border-4 border-[#2D2D2D] max-w-[90%] md:max-w-[465px] max-h-[90%] md:max-h-[300px] object-cover"/>
            </div>
            <div :class="[rtl ? 'order-2 md:order-1' : '']">
                <p class="text-black font-medium text-xl md:text-3xl mb-5">
                    {{ title }}
                </p>
                <div class="mb-10">
                    <template v-if="is_accordion_on">
                        <TextAccordion>
                            <template v-if="text">
                                {{ text }}
                            </template>
                            <template v-else>
                                <slot/>
                            </template>
                        </TextAccordion>
                    </template>
                    <template v-else>
                        <template v-if="text">
                            {{ text }}
                        </template>
                        <template v-else>
                            <slot/>
                        </template>
                    </template>
                </div>
                <CallbackButton class="w-full md:w-auto" :btnText="btnText"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.bg-rtl {
    background: url('@img/services/illustrations/square.svg') no-repeat right bottom;
    background-size: contain;
}
.bg-ltl {
    background: url('@img/services/illustrations/triangle.svg') no-repeat left bottom;
    background-size: contain;
}
</style>
